import _ from 'lodash';

import {Component, Module} from 'app/decorators';

import tpl from './list.html';
import OrderStore from 'app/stores/order';
import OrderStatus from 'app/directives/order.status';


@Module({
    name: "app.orders.components.priority-list",
    modules: [OrderStore, OrderStatus],
})
@Component({
    selector: 'order-priority-list',
    template: tpl,
})
export default class C {
    constructor (OrderStore, $element) {
        "ngInject";
        this.$element = $element;
        this.store = OrderStore;
        this.store.init();
        this.store.params.ordering = 'sort_order';
        this.store.params.view = 'schedule_orders';
        this.store.params.status = 'schedule';
        this.store.params.field = ['id', 'order_id', 'customer', 'status', 'fields', 'crop', 'created_at', 'applicators', 'haulers', 'analysis',];
        this.store.params.page = 1;
        let self = this
        this.store.refresh().then(() => {
            self.prepareLinkedOrders()
        });
        this.saving = false;
    }

    prepareLinkedOrders() {
        let self = this
        let linkedOrders = []
        self.store.list.map(o => o.linked = false)
        self.store.list.forEach(order => {
            if (!linkedOrders.some(l => l.id == order.id)) {
                linkedOrders.push(JSON.parse(JSON.stringify(order)))
                order.haulers.forEach(haul => {
                    let order_linked = haul.linked_with.linked.filter(l => l.split("/")[0] != order.id).map(l => l.split("/")[0])
                    let linked_with = haul.linked_with.linked.map(l => l.split("/")[0])
                    order_linked.forEach(order_id => {
                        if (haul.linked_with.linked.length > 1) {
                            let linkedIndex = self.store.list.findIndex(order => order.id == order_id)
                            if (linkedIndex) {
                                let linkedItem = self.store.list[linkedIndex]
                                linkedItem.linked_class = true
                                linkedItem.linked_with = linked_with
                                linkedOrders[linkedOrders.length-1].linked = true
                                linkedOrders[linkedOrders.length-1].linked_class = true
                                linkedOrders[linkedOrders.length-1].linked_with = linked_with
                                linkedOrders.push(JSON.parse(JSON.stringify(linkedItem)))
                            }
                        }
                    })
                })
            }
        })
        self.store.list = linkedOrders
    }

    onMoved ($index) {
        let self = this;
        self.store.list.splice($index, 1)
    }

    updateLinkedOnDrop(item, itemIndex) {
        let self = this
        item.linked_with.filter(l => l != item.id).forEach((l, index) => {
            let lIndex = self.store.list.findIndex(o => o.id == l)
            let linkedElement = self.store.list.splice(lIndex, 1)[0]
            self.store.list.splice(itemIndex + index + 1, 0, linkedElement)
        })
    }

    onDrop (event, index, item, external, type) {
        let self = this;
        item = self.store.restangularize(item);
        let data = {
            after: this.store.list[index-1],
            before: this.store.list[index],
        };
        self.saving = true;
        item.customPUT(data, 'sort_order')
            .then(i => {
                // item.sort_order = i.sort_order
                if (item.linked_with) self.updateLinkedOnDrop(item, index)
                self.prepareLinkedOrders()
            })
            .finally(() => {self.saving = false});
        return item;
    }

    loadMore () {
        let self = this
        this.store.loadMore().then(() => {
            self.prepareLinkedOrders()
        });
    }

    $onDestroy () {
        this.store = null;
        this.$element.remove();
        this.$element = null;
    }
    //ng-bind="order.applicators.length > 1 ? order.applicators[0].applicator.name+'...' : ''"></td>
    orderApplicators(order) {
        console.log('order', order.applicators.length);
        return order.applicators[0].title;
    }
}



// WEBPACK FOOTER //
// ./src/app/orders/components/priority/main.js